var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#CB0F1B"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.311 0L13.311 22.303 7.974 16.843 7 17.839 14 25 21 17.839 20.026 16.843 14.688 22.303 14.688 0z",
    transform: "translate(-532 -1189) translate(532 1189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7L17.5 8.421 26.601 8.421 26.601 32.579 1.4 32.579 1.4 8.421 10.5 8.421 10.5 7 0 7 0 34 28 34 28 7z",
    transform: "translate(-532 -1189) translate(532 1189)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpload);
export default __webpack_public_path__ + "static/media/ic-upload.607de44469212581cea942d86e605ff9.svg";
export { ForwardRef as ReactComponent };